/**
 * GENERATED FILE — DO NOT EDIT BY HAND.
 *
 * Bundled fallback copy of GET /api/body-regions: the canonical region
 * vocabulary (App\Support\BodyRegions) and the approved artwork
 * (care-homes-api resources/body-map/geometry.json), together.
 *
 * It exists so the body map paints on first load and still paints when the API
 * is unreachable. The live payload always wins once it arrives — see
 * bodyRegions.js / Stores/BodyRegions.
 *
 * Hand-editing this file FAILS the build: `npm start` and `npm run build` both run
 * `generate-body-regions.js --check`, which re-derives `version` from the payload
 * below (the API's own content hash) and diffs the whole file against the API.
 *
 * Regenerate with:  npm run body-regions
 *
 * version: db795c164b4dad8f
 * regions: 122   shapes: 74
 */
const BODY_REGIONS_FALLBACK = {
  "version": "db795c164b4dad8f",
  "view_box": "0 0 260 620",
  "cx": 130,
  "x_scale": 1.14,
  "head_y": 96,
  "silhouettes": {
    "front": [
      [
        0,
        21
      ],
      [
        13,
        24
      ],
      [
        22,
        34
      ],
      [
        26,
        50
      ],
      [
        25,
        68
      ],
      [
        19,
        84
      ],
      [
        13,
        93
      ],
      [
        13.5,
        110
      ],
      [
        28,
        113
      ],
      [
        44,
        119
      ],
      [
        55,
        131
      ],
      [
        60,
        148
      ],
      [
        64,
        178
      ],
      [
        69,
        212
      ],
      [
        73,
        236
      ],
      [
        80,
        272
      ],
      [
        85,
        296
      ],
      [
        90,
        318
      ],
      [
        93,
        340
      ],
      [
        91,
        356
      ],
      [
        84,
        362
      ],
      [
        78,
        358
      ],
      [
        75,
        338
      ],
      [
        71,
        318
      ],
      [
        66,
        296
      ],
      [
        61,
        272
      ],
      [
        57,
        238
      ],
      [
        53,
        214
      ],
      [
        49,
        178
      ],
      [
        47,
        150
      ],
      [
        50,
        152
      ],
      [
        48,
        182
      ],
      [
        44,
        210
      ],
      [
        39,
        234
      ],
      [
        43,
        258
      ],
      [
        50,
        280
      ],
      [
        52,
        298
      ],
      [
        50,
        330
      ],
      [
        46,
        368
      ],
      [
        41,
        404
      ],
      [
        38,
        440
      ],
      [
        34,
        478
      ],
      [
        30,
        516
      ],
      [
        30,
        528
      ],
      [
        34,
        548
      ],
      [
        33,
        562
      ],
      [
        20,
        565
      ],
      [
        11,
        560
      ],
      [
        11,
        540
      ],
      [
        12,
        528
      ],
      [
        13,
        510
      ],
      [
        14,
        478
      ],
      [
        15,
        440
      ],
      [
        12,
        404
      ],
      [
        8,
        364
      ],
      [
        4,
        336
      ],
      [
        2,
        314
      ],
      [
        0,
        308
      ]
    ],
    "back": [
      [
        0,
        21
      ],
      [
        13,
        24
      ],
      [
        22,
        34
      ],
      [
        26,
        50
      ],
      [
        25,
        68
      ],
      [
        19,
        84
      ],
      [
        13,
        93
      ],
      [
        13.5,
        110
      ],
      [
        28,
        113
      ],
      [
        44,
        119
      ],
      [
        55,
        131
      ],
      [
        60,
        148
      ],
      [
        64,
        178
      ],
      [
        69,
        212
      ],
      [
        73,
        236
      ],
      [
        80,
        272
      ],
      [
        85,
        296
      ],
      [
        90,
        318
      ],
      [
        93,
        340
      ],
      [
        91,
        356
      ],
      [
        84,
        362
      ],
      [
        78,
        358
      ],
      [
        75,
        338
      ],
      [
        71,
        318
      ],
      [
        66,
        296
      ],
      [
        61,
        272
      ],
      [
        57,
        238
      ],
      [
        53,
        214
      ],
      [
        49,
        178
      ],
      [
        47,
        150
      ],
      [
        50,
        152
      ],
      [
        48,
        182
      ],
      [
        44,
        210
      ],
      [
        39,
        234
      ],
      [
        43,
        258
      ],
      [
        50,
        282
      ],
      [
        53,
        308
      ],
      [
        51,
        332
      ],
      [
        47,
        356
      ],
      [
        45,
        382
      ],
      [
        41,
        404
      ],
      [
        38,
        440
      ],
      [
        34,
        478
      ],
      [
        30,
        516
      ],
      [
        31,
        527
      ],
      [
        36,
        545
      ],
      [
        35,
        570
      ],
      [
        37,
        588
      ],
      [
        34,
        602
      ],
      [
        22,
        608
      ],
      [
        11,
        603
      ],
      [
        7,
        586
      ],
      [
        8,
        566
      ],
      [
        8,
        545
      ],
      [
        12,
        527
      ],
      [
        13,
        510
      ],
      [
        14,
        478
      ],
      [
        15,
        440
      ],
      [
        13,
        404
      ],
      [
        9,
        382
      ],
      [
        6,
        362
      ],
      [
        4,
        357
      ],
      [
        0,
        356
      ]
    ]
  },
  "figures": {
    "male": {
      "half_front": [
        [
          0,
          21
        ],
        [
          13,
          24
        ],
        [
          22,
          34
        ],
        [
          26,
          50
        ],
        [
          25,
          68
        ],
        [
          19,
          84
        ],
        [
          13,
          93
        ],
        [
          13.5,
          110
        ],
        [
          31,
          113
        ],
        [
          48,
          119
        ],
        [
          58,
          131
        ],
        [
          60,
          148
        ],
        [
          64,
          178
        ],
        [
          69,
          212
        ],
        [
          73,
          236
        ],
        [
          80,
          272
        ],
        [
          85,
          296
        ],
        [
          90,
          318
        ],
        [
          93,
          340
        ],
        [
          91,
          356
        ],
        [
          84,
          362
        ],
        [
          78,
          358
        ],
        [
          75,
          338
        ],
        [
          71,
          318
        ],
        [
          66,
          296
        ],
        [
          61,
          272
        ],
        [
          57,
          238
        ],
        [
          53,
          214
        ],
        [
          49,
          178
        ],
        [
          49,
          150
        ],
        [
          52,
          152
        ],
        [
          50,
          182
        ],
        [
          46,
          210
        ],
        [
          43,
          234
        ],
        [
          43,
          258
        ],
        [
          49,
          280
        ],
        [
          51,
          298
        ],
        [
          50,
          330
        ],
        [
          46,
          368
        ],
        [
          41,
          404
        ],
        [
          38,
          440
        ],
        [
          34,
          478
        ],
        [
          30,
          516
        ],
        [
          30,
          528
        ],
        [
          34,
          548
        ],
        [
          33,
          562
        ],
        [
          20,
          565
        ],
        [
          11,
          560
        ],
        [
          11,
          540
        ],
        [
          12,
          528
        ],
        [
          13,
          510
        ],
        [
          14,
          478
        ],
        [
          15,
          440
        ],
        [
          12,
          404
        ],
        [
          8,
          364
        ],
        [
          4,
          336
        ],
        [
          2,
          314
        ],
        [
          0,
          308
        ]
      ],
      "half_back": [
        [
          0,
          21
        ],
        [
          13,
          24
        ],
        [
          22,
          34
        ],
        [
          26,
          50
        ],
        [
          25,
          68
        ],
        [
          19,
          84
        ],
        [
          13,
          93
        ],
        [
          13.5,
          110
        ],
        [
          31,
          113
        ],
        [
          48,
          119
        ],
        [
          58,
          131
        ],
        [
          60,
          148
        ],
        [
          64,
          178
        ],
        [
          69,
          212
        ],
        [
          73,
          236
        ],
        [
          80,
          272
        ],
        [
          85,
          296
        ],
        [
          90,
          318
        ],
        [
          93,
          340
        ],
        [
          91,
          356
        ],
        [
          84,
          362
        ],
        [
          78,
          358
        ],
        [
          75,
          338
        ],
        [
          71,
          318
        ],
        [
          66,
          296
        ],
        [
          61,
          272
        ],
        [
          57,
          238
        ],
        [
          53,
          214
        ],
        [
          49,
          178
        ],
        [
          49,
          150
        ],
        [
          52,
          152
        ],
        [
          50,
          182
        ],
        [
          46,
          210
        ],
        [
          43,
          234
        ],
        [
          43,
          258
        ],
        [
          49,
          282
        ],
        [
          52,
          308
        ],
        [
          51,
          332
        ],
        [
          47,
          356
        ],
        [
          45,
          382
        ],
        [
          41,
          404
        ],
        [
          38,
          440
        ],
        [
          34,
          478
        ],
        [
          30,
          516
        ],
        [
          31,
          527
        ],
        [
          36,
          545
        ],
        [
          35,
          570
        ],
        [
          37,
          588
        ],
        [
          34,
          602
        ],
        [
          22,
          608
        ],
        [
          11,
          603
        ],
        [
          7,
          586
        ],
        [
          8,
          566
        ],
        [
          8,
          545
        ],
        [
          12,
          527
        ],
        [
          13,
          510
        ],
        [
          14,
          478
        ],
        [
          15,
          440
        ],
        [
          13,
          404
        ],
        [
          9,
          382
        ],
        [
          6,
          362
        ],
        [
          4,
          357
        ],
        [
          0,
          356
        ]
      ],
      "shape_overrides": []
    },
    "female": {
      "half_front": [
        [
          0,
          21
        ],
        [
          13,
          24
        ],
        [
          22,
          34
        ],
        [
          26,
          50
        ],
        [
          25,
          68
        ],
        [
          19,
          84
        ],
        [
          13,
          93
        ],
        [
          13.5,
          110
        ],
        [
          26,
          113
        ],
        [
          41,
          119
        ],
        [
          52,
          131
        ],
        [
          60,
          148
        ],
        [
          64,
          178
        ],
        [
          69,
          212
        ],
        [
          73,
          236
        ],
        [
          80,
          272
        ],
        [
          85,
          296
        ],
        [
          90,
          318
        ],
        [
          93,
          340
        ],
        [
          91,
          356
        ],
        [
          84,
          362
        ],
        [
          78,
          358
        ],
        [
          75,
          338
        ],
        [
          71,
          318
        ],
        [
          66,
          296
        ],
        [
          61,
          272
        ],
        [
          57,
          238
        ],
        [
          53,
          214
        ],
        [
          49,
          178
        ],
        [
          48,
          150
        ],
        [
          52,
          158
        ],
        [
          49,
          182
        ],
        [
          42,
          210
        ],
        [
          36,
          234
        ],
        [
          46,
          258
        ],
        [
          54,
          280
        ],
        [
          55,
          298
        ],
        [
          52,
          330
        ],
        [
          46,
          368
        ],
        [
          41,
          404
        ],
        [
          38,
          440
        ],
        [
          34,
          478
        ],
        [
          30,
          516
        ],
        [
          30,
          528
        ],
        [
          34,
          548
        ],
        [
          33,
          562
        ],
        [
          20,
          565
        ],
        [
          11,
          560
        ],
        [
          11,
          540
        ],
        [
          12,
          528
        ],
        [
          13,
          510
        ],
        [
          14,
          478
        ],
        [
          15,
          440
        ],
        [
          12,
          404
        ],
        [
          8,
          364
        ],
        [
          4,
          336
        ],
        [
          2,
          314
        ],
        [
          0,
          308
        ]
      ],
      "half_back": [
        [
          0,
          21
        ],
        [
          13,
          24
        ],
        [
          22,
          34
        ],
        [
          26,
          50
        ],
        [
          25,
          68
        ],
        [
          19,
          84
        ],
        [
          13,
          93
        ],
        [
          13.5,
          110
        ],
        [
          26,
          113
        ],
        [
          41,
          119
        ],
        [
          52,
          131
        ],
        [
          60,
          148
        ],
        [
          64,
          178
        ],
        [
          69,
          212
        ],
        [
          73,
          236
        ],
        [
          80,
          272
        ],
        [
          85,
          296
        ],
        [
          90,
          318
        ],
        [
          93,
          340
        ],
        [
          91,
          356
        ],
        [
          84,
          362
        ],
        [
          78,
          358
        ],
        [
          75,
          338
        ],
        [
          71,
          318
        ],
        [
          66,
          296
        ],
        [
          61,
          272
        ],
        [
          57,
          238
        ],
        [
          53,
          214
        ],
        [
          49,
          178
        ],
        [
          47,
          150
        ],
        [
          50,
          152
        ],
        [
          48,
          182
        ],
        [
          42,
          210
        ],
        [
          36,
          234
        ],
        [
          46,
          258
        ],
        [
          54,
          282
        ],
        [
          56,
          308
        ],
        [
          53,
          332
        ],
        [
          47,
          356
        ],
        [
          45,
          382
        ],
        [
          41,
          404
        ],
        [
          38,
          440
        ],
        [
          34,
          478
        ],
        [
          30,
          516
        ],
        [
          31,
          527
        ],
        [
          36,
          545
        ],
        [
          35,
          570
        ],
        [
          37,
          588
        ],
        [
          34,
          602
        ],
        [
          22,
          608
        ],
        [
          11,
          603
        ],
        [
          7,
          586
        ],
        [
          8,
          566
        ],
        [
          8,
          545
        ],
        [
          12,
          527
        ],
        [
          13,
          510
        ],
        [
          14,
          478
        ],
        [
          15,
          440
        ],
        [
          13,
          404
        ],
        [
          9,
          382
        ],
        [
          6,
          362
        ],
        [
          4,
          357
        ],
        [
          0,
          356
        ]
      ],
      "shape_overrides": []
    }
  },
  "groups": [
    "Head & neck",
    "Chest & abdomen",
    "Pelvis & perineum",
    "Back",
    "Sacral & buttocks",
    "Arms",
    "Hands",
    "Hips & legs",
    "Feet & ankles"
  ],
  "regions": {
    "vertex": {
      "label": "Scalp (vertex)",
      "group": "Head & neck",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "occiput": {
      "label": "Occiput",
      "group": "Head & neck",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "forehead": {
      "label": "Forehead",
      "group": "Head & neck",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_temple": {
      "label": "Left temple",
      "group": "Head & neck",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "right_temple": {
      "label": "Right temple",
      "group": "Head & neck",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "left_ear": {
      "label": "Left ear",
      "group": "Head & neck",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "right_ear": {
      "label": "Right ear",
      "group": "Head & neck",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "left_cheek": {
      "label": "Left cheek",
      "group": "Head & neck",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "right_cheek": {
      "label": "Right cheek",
      "group": "Head & neck",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "nose": {
      "label": "Nose",
      "group": "Head & neck",
      "view": "front",
      "pressure_site": true,
      "sensitive": false
    },
    "chin": {
      "label": "Chin",
      "group": "Head & neck",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "lips_mouth": {
      "label": "Lips / mouth",
      "group": "Head & neck",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "neck_anterior": {
      "label": "Neck (front)",
      "group": "Head & neck",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "neck_posterior": {
      "label": "Neck (back)",
      "group": "Head & neck",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "left_clavicle": {
      "label": "Left collarbone",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "right_clavicle": {
      "label": "Right collarbone",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "sternum": {
      "label": "Breastbone",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_chest": {
      "label": "Left chest",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "right_chest": {
      "label": "Right chest",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_breast": {
      "label": "Left breast",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": true
    },
    "right_breast": {
      "label": "Right breast",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": true
    },
    "left_under_breast": {
      "label": "Left under-breast (inframammary)",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": true
    },
    "right_under_breast": {
      "label": "Right under-breast (inframammary)",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": true
    },
    "epigastrium": {
      "label": "Upper abdomen (epigastrium)",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "abdomen_central": {
      "label": "Central abdomen",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_upper_abdomen": {
      "label": "Left upper abdomen",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "right_upper_abdomen": {
      "label": "Right upper abdomen",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_lower_abdomen": {
      "label": "Left lower abdomen",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "right_lower_abdomen": {
      "label": "Right lower abdomen",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "abdominal_fold": {
      "label": "Abdominal fold (panniculus)",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_flank": {
      "label": "Left flank",
      "group": "Chest & abdomen",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "right_flank": {
      "label": "Right flank",
      "group": "Chest & abdomen",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "suprapubic": {
      "label": "Suprapubic",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": true
    },
    "left_groin": {
      "label": "Left groin",
      "group": "Pelvis & perineum",
      "view": "front",
      "pressure_site": false,
      "sensitive": true
    },
    "right_groin": {
      "label": "Right groin",
      "group": "Pelvis & perineum",
      "view": "front",
      "pressure_site": false,
      "sensitive": true
    },
    "genitalia": {
      "label": "Genitalia",
      "group": "Pelvis & perineum",
      "view": "front",
      "pressure_site": false,
      "sensitive": true
    },
    "penis": {
      "label": "Penis",
      "group": "Pelvis & perineum",
      "view": "front",
      "pressure_site": false,
      "sensitive": true,
      "figures": [
        "male"
      ]
    },
    "scrotum": {
      "label": "Scrotum",
      "group": "Pelvis & perineum",
      "view": "front",
      "pressure_site": false,
      "sensitive": true,
      "figures": [
        "male"
      ]
    },
    "vulva": {
      "label": "Vulva",
      "group": "Pelvis & perineum",
      "view": "front",
      "pressure_site": false,
      "sensitive": true,
      "figures": [
        "female"
      ]
    },
    "perineum": {
      "label": "Perineum",
      "group": "Pelvis & perineum",
      "view": "both",
      "pressure_site": false,
      "sensitive": true
    },
    "stoma_site": {
      "label": "Stoma site",
      "group": "Chest & abdomen",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_scapula": {
      "label": "Left shoulder blade",
      "group": "Back",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "right_scapula": {
      "label": "Right shoulder blade",
      "group": "Back",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "spine_thoracic": {
      "label": "Spine (thoracic)",
      "group": "Back",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "spine_lumbar": {
      "label": "Spine (lumbar)",
      "group": "Back",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "upper_back_central": {
      "label": "Upper back (central)",
      "group": "Back",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "left_upper_back": {
      "label": "Left upper back",
      "group": "Back",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "right_upper_back": {
      "label": "Right upper back",
      "group": "Back",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "left_lower_back": {
      "label": "Left lower back",
      "group": "Back",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "right_lower_back": {
      "label": "Right lower back",
      "group": "Back",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "sacrum": {
      "label": "Sacrum",
      "group": "Sacral & buttocks",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "coccyx": {
      "label": "Coccyx",
      "group": "Sacral & buttocks",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "left_ischial_tuberosity": {
      "label": "Left ischial tuberosity (sitting bone)",
      "group": "Sacral & buttocks",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "right_ischial_tuberosity": {
      "label": "Right ischial tuberosity (sitting bone)",
      "group": "Sacral & buttocks",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "natal_cleft": {
      "label": "Natal cleft",
      "group": "Sacral & buttocks",
      "view": "back",
      "pressure_site": false,
      "sensitive": true
    },
    "perianal": {
      "label": "Perianal",
      "group": "Pelvis & perineum",
      "view": "back",
      "pressure_site": false,
      "sensitive": true
    },
    "left_buttock": {
      "label": "Left buttock",
      "group": "Sacral & buttocks",
      "view": "back",
      "pressure_site": false,
      "sensitive": true
    },
    "right_buttock": {
      "label": "Right buttock",
      "group": "Sacral & buttocks",
      "view": "back",
      "pressure_site": false,
      "sensitive": true
    },
    "left_shoulder": {
      "label": "Left shoulder",
      "group": "Arms",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "left_deltoid": {
      "label": "Left deltoid",
      "group": "Arms",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "left_upper_arm_anterior": {
      "label": "Left upper arm (front)",
      "group": "Arms",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_upper_arm_posterior": {
      "label": "Left upper arm (back)",
      "group": "Arms",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "left_elbow": {
      "label": "Left elbow",
      "group": "Arms",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "left_olecranon": {
      "label": "Left elbow point (olecranon)",
      "group": "Arms",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "left_forearm_anterior": {
      "label": "Left forearm (front)",
      "group": "Arms",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_forearm_posterior": {
      "label": "Left forearm (back)",
      "group": "Arms",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "left_wrist_anterior": {
      "label": "Left wrist (front)",
      "group": "Hands",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_wrist_posterior": {
      "label": "Left wrist (back)",
      "group": "Hands",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "left_hand_dorsum": {
      "label": "Left hand (back)",
      "group": "Hands",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "left_palm": {
      "label": "Left palm",
      "group": "Hands",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_fingers": {
      "label": "Left fingers",
      "group": "Hands",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "left_thumb": {
      "label": "Left thumb",
      "group": "Hands",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "right_shoulder": {
      "label": "Right shoulder",
      "group": "Arms",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "right_deltoid": {
      "label": "Right deltoid",
      "group": "Arms",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "right_upper_arm_anterior": {
      "label": "Right upper arm (front)",
      "group": "Arms",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "right_upper_arm_posterior": {
      "label": "Right upper arm (back)",
      "group": "Arms",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "right_elbow": {
      "label": "Right elbow",
      "group": "Arms",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "right_olecranon": {
      "label": "Right elbow point (olecranon)",
      "group": "Arms",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "right_forearm_anterior": {
      "label": "Right forearm (front)",
      "group": "Arms",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "right_forearm_posterior": {
      "label": "Right forearm (back)",
      "group": "Arms",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "right_wrist_anterior": {
      "label": "Right wrist (front)",
      "group": "Hands",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "right_wrist_posterior": {
      "label": "Right wrist (back)",
      "group": "Hands",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "right_hand_dorsum": {
      "label": "Right hand (back)",
      "group": "Hands",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "right_palm": {
      "label": "Right palm",
      "group": "Hands",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "right_fingers": {
      "label": "Right fingers",
      "group": "Hands",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "right_thumb": {
      "label": "Right thumb",
      "group": "Hands",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "left_hip": {
      "label": "Left hip",
      "group": "Hips & legs",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "left_greater_trochanter": {
      "label": "Left hip bone (greater trochanter)",
      "group": "Hips & legs",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "left_thigh_anterior": {
      "label": "Left thigh (front)",
      "group": "Hips & legs",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_thigh_posterior": {
      "label": "Left thigh (back)",
      "group": "Hips & legs",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "left_thigh_medial": {
      "label": "Left inner thigh",
      "group": "Hips & legs",
      "view": "both",
      "pressure_site": false,
      "sensitive": true
    },
    "left_thigh_lateral": {
      "label": "Left outer thigh",
      "group": "Hips & legs",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "left_knee_anterior": {
      "label": "Left knee (front)",
      "group": "Hips & legs",
      "view": "front",
      "pressure_site": true,
      "sensitive": false
    },
    "left_knee_posterior": {
      "label": "Left back of knee",
      "group": "Hips & legs",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "left_shin": {
      "label": "Left shin",
      "group": "Hips & legs",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_calf": {
      "label": "Left calf",
      "group": "Hips & legs",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "left_medial_malleolus": {
      "label": "Left inner ankle bone",
      "group": "Feet & ankles",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "left_lateral_malleolus": {
      "label": "Left outer ankle bone",
      "group": "Feet & ankles",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "left_achilles": {
      "label": "Left Achilles tendon",
      "group": "Feet & ankles",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "left_heel": {
      "label": "Left heel",
      "group": "Feet & ankles",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "left_foot_dorsum": {
      "label": "Left top of foot",
      "group": "Feet & ankles",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "left_sole": {
      "label": "Left sole",
      "group": "Feet & ankles",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "left_great_toe": {
      "label": "Left big toe",
      "group": "Feet & ankles",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "left_toes": {
      "label": "Left toes",
      "group": "Feet & ankles",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "right_hip": {
      "label": "Right hip",
      "group": "Hips & legs",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "right_greater_trochanter": {
      "label": "Right hip bone (greater trochanter)",
      "group": "Hips & legs",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "right_thigh_anterior": {
      "label": "Right thigh (front)",
      "group": "Hips & legs",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "right_thigh_posterior": {
      "label": "Right thigh (back)",
      "group": "Hips & legs",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "right_thigh_medial": {
      "label": "Right inner thigh",
      "group": "Hips & legs",
      "view": "both",
      "pressure_site": false,
      "sensitive": true
    },
    "right_thigh_lateral": {
      "label": "Right outer thigh",
      "group": "Hips & legs",
      "view": "both",
      "pressure_site": false,
      "sensitive": false
    },
    "right_knee_anterior": {
      "label": "Right knee (front)",
      "group": "Hips & legs",
      "view": "front",
      "pressure_site": true,
      "sensitive": false
    },
    "right_knee_posterior": {
      "label": "Right back of knee",
      "group": "Hips & legs",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "right_shin": {
      "label": "Right shin",
      "group": "Hips & legs",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "right_calf": {
      "label": "Right calf",
      "group": "Hips & legs",
      "view": "back",
      "pressure_site": false,
      "sensitive": false
    },
    "right_medial_malleolus": {
      "label": "Right inner ankle bone",
      "group": "Feet & ankles",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "right_lateral_malleolus": {
      "label": "Right outer ankle bone",
      "group": "Feet & ankles",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "right_achilles": {
      "label": "Right Achilles tendon",
      "group": "Feet & ankles",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "right_heel": {
      "label": "Right heel",
      "group": "Feet & ankles",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "right_foot_dorsum": {
      "label": "Right top of foot",
      "group": "Feet & ankles",
      "view": "front",
      "pressure_site": false,
      "sensitive": false
    },
    "right_sole": {
      "label": "Right sole",
      "group": "Feet & ankles",
      "view": "back",
      "pressure_site": true,
      "sensitive": false
    },
    "right_great_toe": {
      "label": "Right big toe",
      "group": "Feet & ankles",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    },
    "right_toes": {
      "label": "Right toes",
      "group": "Feet & ankles",
      "view": "both",
      "pressure_site": true,
      "sensitive": false
    }
  },
  "shapes": {
    "vertex": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              -25,
              48
            ],
            [
              -23,
              32
            ],
            [
              -12,
              22
            ],
            [
              0,
              19
            ],
            [
              12,
              22
            ],
            [
              23,
              32
            ],
            [
              25,
              48
            ],
            [
              12,
              42
            ],
            [
              0,
              40
            ],
            [
              -12,
              42
            ]
          ],
          "r": 0.45
        }
      ],
      "back": [
        {
          "t": "p",
          "pts": [
            [
              -25,
              48
            ],
            [
              -23,
              32
            ],
            [
              -12,
              22
            ],
            [
              0,
              19
            ],
            [
              12,
              22
            ],
            [
              23,
              32
            ],
            [
              25,
              48
            ],
            [
              12,
              42
            ],
            [
              0,
              40
            ],
            [
              -12,
              42
            ]
          ],
          "r": 0.45
        }
      ]
    },
    "occiput": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              -25,
              48
            ],
            [
              -12,
              42
            ],
            [
              0,
              40
            ],
            [
              12,
              42
            ],
            [
              25,
              48
            ],
            [
              20,
              72
            ],
            [
              12,
              86
            ],
            [
              0,
              90
            ],
            [
              -12,
              86
            ],
            [
              -20,
              72
            ]
          ],
          "r": 0.45
        }
      ]
    },
    "forehead": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              -25,
              48
            ],
            [
              -12,
              42
            ],
            [
              0,
              40
            ],
            [
              12,
              42
            ],
            [
              25,
              48
            ],
            [
              22,
              62
            ],
            [
              0,
              65
            ],
            [
              -22,
              62
            ]
          ],
          "r": 0.45
        }
      ]
    },
    "nose": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              -3,
              60
            ],
            [
              0,
              57
            ],
            [
              3,
              60
            ],
            [
              3,
              70
            ],
            [
              5,
              76
            ],
            [
              0,
              79
            ],
            [
              -5,
              76
            ],
            [
              -3,
              70
            ]
          ],
          "r": 0.5
        }
      ]
    },
    "lips_mouth": {
      "front": [
        {
          "t": "e",
          "cx": 0,
          "cy": 86,
          "rx": 7,
          "ry": 3.5
        }
      ]
    },
    "chin": {
      "front": [
        {
          "t": "e",
          "cx": 0,
          "cy": 92,
          "rx": 7.5,
          "ry": 4.5
        }
      ]
    },
    "neck_anterior": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              -12,
              93
            ],
            [
              12,
              93
            ],
            [
              14,
              112
            ],
            [
              -14,
              112
            ]
          ],
          "r": 0.25
        }
      ]
    },
    "neck_posterior": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              -12,
              91
            ],
            [
              12,
              91
            ],
            [
              14,
              116
            ],
            [
              -14,
              116
            ]
          ],
          "r": 0.25
        }
      ]
    },
    "sternum": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              -7,
              124
            ],
            [
              7,
              124
            ],
            [
              8,
              176
            ],
            [
              -8,
              176
            ]
          ],
          "r": 0.2
        }
      ]
    },
    "epigastrium": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              -16,
              177
            ],
            [
              16,
              177
            ],
            [
              15,
              206
            ],
            [
              -15,
              206
            ]
          ],
          "r": 0.3
        }
      ]
    },
    "abdomen_central": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              -15,
              207
            ],
            [
              15,
              207
            ],
            [
              16,
              250
            ],
            [
              -16,
              250
            ]
          ],
          "r": 0.3
        }
      ]
    },
    "suprapubic": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              -17,
              251
            ],
            [
              17,
              251
            ],
            [
              18,
              278
            ],
            [
              -18,
              278
            ]
          ],
          "r": 0.3
        }
      ]
    },
    "genitalia": {
      "front": [
        {
          "t": "e",
          "cx": 0,
          "cy": 287,
          "rx": 12,
          "ry": 11
        }
      ]
    },
    "penis": {
      "front": [
        {
          "t": "e",
          "cx": 0,
          "cy": 286,
          "rx": 6,
          "ry": 9
        }
      ]
    },
    "scrotum": {
      "front": [
        {
          "t": "e",
          "cx": 0,
          "cy": 297,
          "rx": 9,
          "ry": 7
        }
      ]
    },
    "vulva": {
      "front": [
        {
          "t": "e",
          "cx": 0,
          "cy": 290,
          "rx": 8,
          "ry": 9
        }
      ]
    },
    "perineum": {
      "front": [
        {
          "t": "e",
          "cx": 0,
          "cy": 301,
          "rx": 8,
          "ry": 5
        }
      ],
      "back": [
        {
          "t": "e",
          "cx": 0,
          "cy": 348,
          "rx": 8,
          "ry": 6
        }
      ]
    },
    "stoma_site": {
      "front": [
        {
          "t": "e",
          "cx": -24,
          "cy": 232,
          "rx": 7,
          "ry": 7
        }
      ]
    },
    "upper_back_central": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              -17,
              118
            ],
            [
              17,
              118
            ],
            [
              16,
              216
            ],
            [
              -16,
              216
            ]
          ],
          "r": 0.25
        }
      ]
    },
    "spine_thoracic": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              -6,
              120
            ],
            [
              6,
              120
            ],
            [
              6,
              218
            ],
            [
              -6,
              218
            ]
          ],
          "r": 0.15
        }
      ]
    },
    "spine_lumbar": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              -6,
              218
            ],
            [
              6,
              218
            ],
            [
              7,
              272
            ],
            [
              -7,
              272
            ]
          ],
          "r": 0.15
        }
      ]
    },
    "sacrum": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              -17,
              272
            ],
            [
              17,
              272
            ],
            [
              12,
              297
            ],
            [
              0,
              313
            ],
            [
              -12,
              297
            ]
          ],
          "r": 0.2
        }
      ]
    },
    "coccyx": {
      "back": [
        {
          "t": "e",
          "cx": 0,
          "cy": 319,
          "rx": 6.5,
          "ry": 7.5
        }
      ]
    },
    "natal_cleft": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              -5,
              324
            ],
            [
              5,
              324
            ],
            [
              4,
              342
            ],
            [
              -4,
              342
            ]
          ],
          "r": 0.3
        }
      ]
    },
    "perianal": {
      "back": [
        {
          "t": "e",
          "cx": 0,
          "cy": 338,
          "rx": 4,
          "ry": 4
        }
      ]
    },
    "temple": {
      "front": [
        {
          "t": "e",
          "cx": 19,
          "cy": 55,
          "rx": 5.5,
          "ry": 7
        }
      ],
      "back": [
        {
          "t": "e",
          "cx": 19,
          "cy": 55,
          "rx": 5.5,
          "ry": 7
        }
      ]
    },
    "ear": {
      "front": [
        {
          "t": "e",
          "cx": 21,
          "cy": 72,
          "rx": 4,
          "ry": 8
        }
      ],
      "back": [
        {
          "t": "e",
          "cx": 20,
          "cy": 71,
          "rx": 5,
          "ry": 9
        }
      ]
    },
    "cheek": {
      "front": [
        {
          "t": "e",
          "cx": 15,
          "cy": 77,
          "rx": 8,
          "ry": 6.5
        }
      ]
    },
    "clavicle": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              5,
              114
            ],
            [
              34,
              117
            ],
            [
              46,
              126
            ],
            [
              42,
              131
            ],
            [
              6,
              124
            ]
          ],
          "r": 0.3
        }
      ]
    },
    "chest": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              8,
              126
            ],
            [
              42,
              130
            ],
            [
              48,
              150
            ],
            [
              45,
              172
            ],
            [
              9,
              170
            ]
          ],
          "r": 0.5
        }
      ]
    },
    "breast": {
      "front": [
        {
          "t": "e",
          "cx": 25,
          "cy": 161,
          "rx": 13,
          "ry": 11
        }
      ]
    },
    "under_breast": {
      "front": [
        {
          "t": "e",
          "cx": 25,
          "cy": 176,
          "rx": 12,
          "ry": 5
        }
      ]
    },
    "upper_abdomen": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              16,
              177
            ],
            [
              38,
              174
            ],
            [
              36,
              206
            ],
            [
              15,
              206
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "lower_abdomen": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              16,
              207
            ],
            [
              37,
              207
            ],
            [
              40,
              232
            ],
            [
              38,
              252
            ],
            [
              16,
              251
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "abdominal_fold": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              -17,
              240
            ],
            [
              17,
              240
            ],
            [
              18,
              250
            ],
            [
              -18,
              250
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "flank": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              36,
              172
            ],
            [
              48,
              170
            ],
            [
              45,
              206
            ],
            [
              40,
              238
            ],
            [
              33,
              236
            ]
          ],
          "r": 0.5
        }
      ],
      "back": [
        {
          "t": "p",
          "pts": [
            [
              40,
              180
            ],
            [
              48,
              176
            ],
            [
              45,
              212
            ],
            [
              38,
              240
            ],
            [
              32,
              236
            ]
          ],
          "r": 0.5
        }
      ]
    },
    "groin": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              18,
              254
            ],
            [
              42,
              258
            ],
            [
              46,
              276
            ],
            [
              30,
              292
            ],
            [
              17,
              286
            ]
          ],
          "r": 0.5
        }
      ]
    },
    "upper_back": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              17,
              120
            ],
            [
              46,
              124
            ],
            [
              49,
              152
            ],
            [
              45,
              180
            ],
            [
              40,
              216
            ],
            [
              16,
              216
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "scapula": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              20,
              140
            ],
            [
              45,
              136
            ],
            [
              47,
              158
            ],
            [
              39,
              182
            ],
            [
              26,
              176
            ],
            [
              19,
              157
            ]
          ],
          "r": 0.35
        }
      ]
    },
    "lower_back": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              6,
              218
            ],
            [
              38,
              216
            ],
            [
              43,
              244
            ],
            [
              47,
              272
            ],
            [
              6,
              272
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "buttock": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              8,
              278
            ],
            [
              40,
              272
            ],
            [
              50,
              290
            ],
            [
              52,
              312
            ],
            [
              46,
              338
            ],
            [
              30,
              352
            ],
            [
              12,
              348
            ],
            [
              7,
              316
            ]
          ],
          "r": 0.55
        }
      ]
    },
    "ischial_tuberosity": {
      "back": [
        {
          "t": "e",
          "cx": 25,
          "cy": 340,
          "rx": 9,
          "ry": 8
        }
      ]
    },
    "shoulder": {
      "front": [
        {
          "t": "e",
          "cx": 48,
          "cy": 128,
          "rx": 13,
          "ry": 11
        }
      ],
      "back": [
        {
          "t": "e",
          "cx": 48,
          "cy": 128,
          "rx": 13,
          "ry": 11
        }
      ]
    },
    "deltoid": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              42,
              136
            ],
            [
              57,
              132
            ],
            [
              62,
              166
            ],
            [
              47,
              170
            ]
          ],
          "r": 0.5
        }
      ],
      "back": [
        {
          "t": "p",
          "pts": [
            [
              42,
              136
            ],
            [
              57,
              132
            ],
            [
              62,
              166
            ],
            [
              47,
              170
            ]
          ],
          "r": 0.5
        }
      ]
    },
    "upper_arm_anterior": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              47,
              170
            ],
            [
              62,
              166
            ],
            [
              67,
              210
            ],
            [
              52,
              214
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "upper_arm_posterior": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              47,
              170
            ],
            [
              62,
              166
            ],
            [
              67,
              210
            ],
            [
              52,
              214
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "elbow": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              52,
              214
            ],
            [
              67,
              210
            ],
            [
              71,
              234
            ],
            [
              56,
              238
            ]
          ],
          "r": 0.65
        }
      ],
      "back": [
        {
          "t": "p",
          "pts": [
            [
              52,
              214
            ],
            [
              67,
              210
            ],
            [
              71,
              234
            ],
            [
              56,
              238
            ]
          ],
          "r": 0.65
        }
      ]
    },
    "olecranon": {
      "back": [
        {
          "t": "e",
          "cx": 62,
          "cy": 224,
          "rx": 8,
          "ry": 8
        }
      ]
    },
    "forearm_anterior": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              56,
              238
            ],
            [
              71,
              234
            ],
            [
              79,
              284
            ],
            [
              64,
              289
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "forearm_posterior": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              56,
              238
            ],
            [
              71,
              234
            ],
            [
              79,
              284
            ],
            [
              64,
              289
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "wrist_anterior": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              64,
              289
            ],
            [
              79,
              284
            ],
            [
              82,
              302
            ],
            [
              67,
              307
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "wrist_posterior": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              64,
              289
            ],
            [
              79,
              284
            ],
            [
              82,
              302
            ],
            [
              67,
              307
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "palm": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              67,
              307
            ],
            [
              82,
              302
            ],
            [
              88,
              332
            ],
            [
              73,
              337
            ]
          ],
          "r": 0.5
        }
      ]
    },
    "hand_dorsum": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              67,
              307
            ],
            [
              82,
              302
            ],
            [
              88,
              332
            ],
            [
              73,
              337
            ]
          ],
          "r": 0.5
        }
      ]
    },
    "fingers": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              73,
              337
            ],
            [
              88,
              332
            ],
            [
              90,
              356
            ],
            [
              77,
              359
            ]
          ],
          "r": 0.5
        }
      ],
      "back": [
        {
          "t": "p",
          "pts": [
            [
              73,
              337
            ],
            [
              88,
              332
            ],
            [
              90,
              356
            ],
            [
              77,
              359
            ]
          ],
          "r": 0.5
        }
      ]
    },
    "thumb": {
      "front": [
        {
          "t": "e",
          "cx": 84,
          "cy": 314,
          "rx": 5,
          "ry": 9.5
        }
      ],
      "back": [
        {
          "t": "e",
          "cx": 84,
          "cy": 314,
          "rx": 5,
          "ry": 9.5
        }
      ]
    },
    "hip": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              33,
              250
            ],
            [
              46,
              254
            ],
            [
              51,
              282
            ],
            [
              40,
              288
            ],
            [
              31,
              272
            ]
          ],
          "r": 0.5
        }
      ],
      "back": [
        {
          "t": "p",
          "pts": [
            [
              35,
              252
            ],
            [
              49,
              256
            ],
            [
              53,
              286
            ],
            [
              42,
              292
            ],
            [
              33,
              274
            ]
          ],
          "r": 0.5
        }
      ]
    },
    "greater_trochanter": {
      "front": [
        {
          "t": "e",
          "cx": 45,
          "cy": 290,
          "rx": 9,
          "ry": 9
        }
      ],
      "back": [
        {
          "t": "e",
          "cx": 46,
          "cy": 292,
          "rx": 9,
          "ry": 9
        }
      ]
    },
    "thigh_anterior": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              7,
              312
            ],
            [
              47,
              304
            ],
            [
              45,
              352
            ],
            [
              41,
              402
            ],
            [
              15,
              402
            ],
            [
              9,
              352
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "thigh_posterior": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              6,
              358
            ],
            [
              46,
              352
            ],
            [
              44,
              400
            ],
            [
              41,
              404
            ],
            [
              14,
              404
            ],
            [
              7,
              392
            ]
          ],
          "r": 0.45
        }
      ]
    },
    "thigh_medial": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              4,
              316
            ],
            [
              16,
              310
            ],
            [
              18,
              352
            ],
            [
              16,
              396
            ],
            [
              9,
              394
            ],
            [
              5,
              350
            ]
          ],
          "r": 0.4
        }
      ],
      "back": [
        {
          "t": "p",
          "pts": [
            [
              4,
              360
            ],
            [
              16,
              356
            ],
            [
              18,
              394
            ],
            [
              10,
              398
            ],
            [
              5,
              384
            ]
          ],
          "r": 0.45
        }
      ]
    },
    "thigh_lateral": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              38,
              306
            ],
            [
              49,
              304
            ],
            [
              46,
              352
            ],
            [
              42,
              398
            ],
            [
              36,
              396
            ],
            [
              37,
              350
            ]
          ],
          "r": 0.4
        }
      ],
      "back": [
        {
          "t": "p",
          "pts": [
            [
              38,
              354
            ],
            [
              48,
              352
            ],
            [
              45,
              398
            ],
            [
              38,
              398
            ]
          ],
          "r": 0.45
        }
      ]
    },
    "knee_anterior": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              15,
              402
            ],
            [
              41,
              402
            ],
            [
              39,
              438
            ],
            [
              16,
              438
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "knee_posterior": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              15,
              404
            ],
            [
              41,
              404
            ],
            [
              39,
              438
            ],
            [
              16,
              438
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "shin": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              16,
              438
            ],
            [
              39,
              438
            ],
            [
              33,
              484
            ],
            [
              30,
              520
            ],
            [
              14,
              520
            ],
            [
              15,
              482
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "calf": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              16,
              438
            ],
            [
              39,
              438
            ],
            [
              34,
              484
            ],
            [
              30,
              514
            ],
            [
              14,
              514
            ],
            [
              15,
              482
            ]
          ],
          "r": 0.45
        }
      ]
    },
    "achilles": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              17,
              500
            ],
            [
              29,
              500
            ],
            [
              28,
              528
            ],
            [
              18,
              528
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "medial_malleolus": {
      "front": [
        {
          "t": "e",
          "cx": 16,
          "cy": 522,
          "rx": 6.5,
          "ry": 6.5
        }
      ],
      "back": [
        {
          "t": "e",
          "cx": 15,
          "cy": 524,
          "rx": 6.5,
          "ry": 6.5
        }
      ]
    },
    "lateral_malleolus": {
      "front": [
        {
          "t": "e",
          "cx": 29,
          "cy": 522,
          "rx": 6.5,
          "ry": 6.5
        }
      ],
      "back": [
        {
          "t": "e",
          "cx": 30,
          "cy": 524,
          "rx": 6.5,
          "ry": 6.5
        }
      ]
    },
    "heel": {
      "back": [
        {
          "t": "e",
          "cx": 22,
          "cy": 543,
          "rx": 14,
          "ry": 15
        }
      ]
    },
    "sole": {
      "back": [
        {
          "t": "p",
          "pts": [
            [
              11,
              556
            ],
            [
              33,
              556
            ],
            [
              36,
              578
            ],
            [
              33,
              590
            ],
            [
              13,
              590
            ],
            [
              8,
              576
            ]
          ],
          "r": 0.5
        }
      ]
    },
    "foot_dorsum": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              13,
              528
            ],
            [
              30,
              528
            ],
            [
              33,
              548
            ],
            [
              30,
              552
            ],
            [
              15,
              551
            ],
            [
              12,
              540
            ]
          ],
          "r": 0.4
        }
      ]
    },
    "great_toe": {
      "front": [
        {
          "t": "e",
          "cx": 15,
          "cy": 554,
          "rx": 5.5,
          "ry": 6
        }
      ],
      "back": [
        {
          "t": "e",
          "cx": 13,
          "cy": 596,
          "rx": 6.5,
          "ry": 7
        }
      ]
    },
    "toes": {
      "front": [
        {
          "t": "p",
          "pts": [
            [
              20,
              549
            ],
            [
              32,
              551
            ],
            [
              31,
              561
            ],
            [
              21,
              562
            ]
          ],
          "r": 0.4
        }
      ],
      "back": [
        {
          "t": "p",
          "pts": [
            [
              20,
              589
            ],
            [
              34,
              590
            ],
            [
              34,
              602
            ],
            [
              21,
              603
            ]
          ],
          "r": 0.4
        }
      ]
    }
  },
  "order": {
    "front": [
      "vertex",
      "forehead",
      "left_temple",
      "right_temple",
      "left_cheek",
      "right_cheek",
      "nose",
      "lips_mouth",
      "chin",
      "left_ear",
      "right_ear",
      "neck_anterior",
      "sternum",
      "left_chest",
      "right_chest",
      "left_clavicle",
      "right_clavicle",
      "left_breast",
      "right_breast",
      "left_under_breast",
      "right_under_breast",
      "epigastrium",
      "left_upper_abdomen",
      "right_upper_abdomen",
      "abdomen_central",
      "left_lower_abdomen",
      "right_lower_abdomen",
      "abdominal_fold",
      "left_flank",
      "right_flank",
      "suprapubic",
      "left_groin",
      "right_groin",
      "genitalia",
      "penis",
      "scrotum",
      "vulva",
      "perineum",
      "stoma_site",
      "left_shoulder",
      "right_shoulder",
      "left_deltoid",
      "right_deltoid",
      "left_upper_arm_anterior",
      "right_upper_arm_anterior",
      "left_elbow",
      "right_elbow",
      "left_forearm_anterior",
      "right_forearm_anterior",
      "left_wrist_anterior",
      "right_wrist_anterior",
      "left_palm",
      "right_palm",
      "left_fingers",
      "right_fingers",
      "left_thumb",
      "right_thumb",
      "left_hip",
      "right_hip",
      "left_thigh_anterior",
      "right_thigh_anterior",
      "left_thigh_medial",
      "right_thigh_medial",
      "left_thigh_lateral",
      "right_thigh_lateral",
      "left_greater_trochanter",
      "right_greater_trochanter",
      "left_knee_anterior",
      "right_knee_anterior",
      "left_shin",
      "right_shin",
      "left_foot_dorsum",
      "right_foot_dorsum",
      "left_medial_malleolus",
      "right_medial_malleolus",
      "left_lateral_malleolus",
      "right_lateral_malleolus",
      "left_great_toe",
      "right_great_toe",
      "left_toes",
      "right_toes"
    ],
    "back": [
      "vertex",
      "occiput",
      "left_temple",
      "right_temple",
      "left_ear",
      "right_ear",
      "neck_posterior",
      "upper_back_central",
      "left_upper_back",
      "right_upper_back",
      "left_scapula",
      "right_scapula",
      "spine_thoracic",
      "left_lower_back",
      "right_lower_back",
      "left_flank",
      "right_flank",
      "spine_lumbar",
      "left_buttock",
      "right_buttock",
      "sacrum",
      "coccyx",
      "natal_cleft",
      "perianal",
      "perineum",
      "left_ischial_tuberosity",
      "right_ischial_tuberosity",
      "left_shoulder",
      "right_shoulder",
      "left_deltoid",
      "right_deltoid",
      "left_upper_arm_posterior",
      "right_upper_arm_posterior",
      "left_elbow",
      "right_elbow",
      "left_olecranon",
      "right_olecranon",
      "left_forearm_posterior",
      "right_forearm_posterior",
      "left_wrist_posterior",
      "right_wrist_posterior",
      "left_hand_dorsum",
      "right_hand_dorsum",
      "left_fingers",
      "right_fingers",
      "left_thumb",
      "right_thumb",
      "left_hip",
      "right_hip",
      "left_thigh_posterior",
      "right_thigh_posterior",
      "left_thigh_medial",
      "right_thigh_medial",
      "left_thigh_lateral",
      "right_thigh_lateral",
      "left_greater_trochanter",
      "right_greater_trochanter",
      "left_knee_posterior",
      "right_knee_posterior",
      "left_calf",
      "right_calf",
      "left_achilles",
      "right_achilles",
      "left_medial_malleolus",
      "right_medial_malleolus",
      "left_lateral_malleolus",
      "right_lateral_malleolus",
      "left_heel",
      "right_heel",
      "left_sole",
      "right_sole",
      "left_great_toe",
      "right_great_toe",
      "left_toes",
      "right_toes"
    ]
  },
  "legacy": {
    "aliases": {
      "head": "vertex",
      "hair": "vertex",
      "neck": "neck_anterior",
      "trapezius": "neck_posterior",
      "upper_back": "upper_back_central",
      "abs": "abdomen_central",
      "left_chest": "left_chest",
      "right_chest": "right_chest",
      "left_shoulder": "left_shoulder",
      "right_shoulder": "right_shoulder",
      "left_deltoids": "left_deltoid",
      "right_deltoids": "right_deltoid",
      "left_biceps": "left_upper_arm_anterior",
      "right_biceps": "right_upper_arm_anterior",
      "left_triceps": "left_upper_arm_posterior",
      "right_triceps": "right_upper_arm_posterior",
      "left_elbows": "left_elbow",
      "right_elbows": "right_elbow",
      "left_gluteal": "left_buttock",
      "right_gluteal": "right_buttock",
      "left_quadriceps": "left_thigh_anterior",
      "right_quadriceps": "right_thigh_anterior",
      "left_hamstring": "left_thigh_posterior",
      "right_hamstring": "right_thigh_posterior",
      "left_adductors": "left_thigh_medial",
      "right_adductors": "right_thigh_medial",
      "left_obliques": "left_flank",
      "right_obliques": "right_flank",
      "front_left_forearm": "left_forearm_anterior",
      "front_right_forearm": "right_forearm_anterior",
      "back_left_forearm": "left_forearm_posterior",
      "back_right_forearm": "right_forearm_posterior",
      "front_left_knees": "left_knee_anterior",
      "front_right_knees": "right_knee_anterior",
      "back_left_knees": "left_knee_posterior",
      "back_right_knees": "right_knee_posterior",
      "front_left_tibialis": "left_shin",
      "front_right_tibialis": "right_shin",
      "back_left_calves": "left_calf",
      "back_right_calves": "right_calf",
      "front_left_hips": "left_hip",
      "front_right_hips": "right_hip",
      "front_left_hands": "left_palm",
      "front_right_hands": "right_palm",
      "back_left_hands": "left_hand_dorsum",
      "back_right_hands": "right_hand_dorsum",
      "front_left_toes": "left_toes",
      "front_right_toes": "right_toes",
      "back_left_toes": "left_toes",
      "back_right_toes": "right_toes"
    },
    "needs_confirmation": [
      "lower_back",
      "ears",
      "eyes",
      "front_left_feet",
      "front_right_feet",
      "back_left_feet",
      "back_right_feet",
      "front_left_ankles",
      "front_right_ankles",
      "back_left_ankles",
      "back_right_ankles",
      "front_left_wrists",
      "front_right_wrists",
      "back_left_wrists",
      "back_right_wrists",
      "back_left_tibialis",
      "back_right_tibialis",
      "front_left_calves",
      "front_right_calves",
      "back_left_hips",
      "back_right_hips"
    ]
  },
  "wound_categories": {
    "order": [
      "grade_1",
      "grade_2",
      "grade_3",
      "grade_4",
      "unstageable",
      "sdti"
    ],
    "labels": {
      "grade_1": "Category 1",
      "grade_2": "Category 2",
      "grade_3": "Category 3",
      "grade_4": "Category 4",
      "unstageable": "Unstageable",
      "sdti": "Deep tissue injury"
    },
    "descriptions": {
      "grade_1": "Non-blanchable erythema of intact skin",
      "grade_2": "Partial-thickness skin loss with exposed dermis",
      "grade_3": "Full-thickness skin loss",
      "grade_4": "Full-thickness skin and tissue loss",
      "unstageable": "Obscured full-thickness skin and tissue loss — depth cannot be assessed until the base is visible",
      "sdti": "Persistent non-blanchable deep red, maroon or purple discolouration — depth not yet knowable"
    },
    "ordinal": {
      "grade_1": 1,
      "grade_2": 2,
      "grade_3": 3,
      "grade_4": 4
    },
    "off_scale": [
      "unstageable",
      "sdti"
    ],
    "severe": [
      "grade_3",
      "grade_4",
      "unstageable",
      "sdti"
    ]
  }
};

export default BODY_REGIONS_FALLBACK;
